import React from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';

import ListView from '../Common/ListView.react';
import ListItem from '../User/UserListItem';
import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';

import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import UpIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import DownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';

import DepartmentActions from '../../actions/DepartmentActionCreator';
import DepartmentStore from '../../stores/DepartmentStore';
import DepartmentMemberStore from '../../stores/DepartmentMemberStore';

import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';

const Department = React.createClass({

    getInitialState: function () {

        return {
            details: {
                id: '',
                name: '',
                description: '',
                sysStatus: 0,
            },
            members: [],
            actions: [],
            limit: 50,
            page: 0,
            loading: false,
            fetchedAll: false,
            showButton: false,
            menuItems: [
                {
                    link: '/dashboard/department/' + this.props.routeParams.id + '/edit',
                    icon: <EditIcon />,
                    label: 'Edit',
                    condition: {
                        roles: [ROLES.ADMIN]
                    }
                },
                {
                    type: 'deleteDialog',
                    dialogType: 'menu',
                    value: this.props.routeParams.id,
                    title: 'Delete ',
                    deleteAction: this._onDelete,
                    message: (
                                <span>
                                    Are you sure you want to delete this department?
                                </span>
                            ),
                    condition: {
                        roles: [ROLES.ADMIN]
                    }
                }
            ],
            links: {
                back: '/dashboard/departments',
                edit: '',
            }
        }
    },

    componentDidMount: function() {
        this.listeners = [
            DepartmentStore.addListener(this._onChange),
            DepartmentMemberStore.addListener(this._onMemberChange)
        ];
        DepartmentActions.getById(this.props.routeParams.id);
        DepartmentActions.getMembers(this.props.routeParams.id, {limit: this.state.limit});

        window.addEventListener('scroll', this.handleScroll);

        this.setState(assign(this.state, {actions: buildContextMenu(this.state.menuItems, this.context.auth)}));
    },

    componentWillUnmount: function() {
        this.listeners.forEach(listener => listener.remove());

        window.removeEventListener('scroll', this.handleScroll);
    },

    render: function() {

        let title = this.state.details.name;
        if (!!this.state.details.organisation) {
            title += ' (' + this.state.details.organisation + ')';
        }
        return(
            <div ref="departmentUsers">
                <ListView
                    title={title}
                    items={this.state.members}
                    itemDecorator={ListItem}
                    actions={this.state.actions}
                />
                {this.state.loading && (
                    <LinearProgress mode="indeterminate" />
                )}
                {this.state.showButton && (
                    <FlatButton
                        label={this.state.fetchedAll ? 'Back to top' : 'Load more'}
                        icon={this.state.fetchedAll ? <UpIcon/> : <DownIcon/>}
                        onTouchTap={this.state.fetchedAll ? () => window.scrollTo(0, 0) : this.loadNextPage}
                        disabled={this.state.loading}
                        fullWidth
                    />
                )}
            </div>
        );
    },

    _onChange: function() {
        const details = DepartmentStore.getById(this.props.routeParams.id);
        if (details !== undefined) {
            this.setState({details: details});
        }
    },

    _onMemberChange: function() {
        const members = DepartmentMemberStore.getMembers(this.props.routeParams.id);
        if (members !== undefined) {
            this.setState({members, loading: false, fetchedAll: DepartmentMemberStore.fetchedAll()});
        }
    },

    _onDelete: function(entityId) {
        if (entityId == this.props.routeParams.id) {
            DepartmentActions.delete(entityId);
            window.location.href = this.state.links.back;
        }
    },

    loadNextPage: function() {
        if (this.state.loading) { return; } //guard

        const page = (this.state.page + 1);
        DepartmentActions.getMembers(this.props.routeParams.id, {page, limit: this.state.limit}, false);
        this.setState({page, loading: true});
    },

    handleScroll: function() {
        if (!this.state.showButton) {
            this.setState({showButton: true});
        }
        if (!this.state.fetchedAll && (window.scrollY + window.innerHeight) >= this.refs.departmentUsers.clientHeight) {
            this.loadNextPage();
        }
    }

});

Department.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default Department;
